import type { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { client } from '../common';
import type { Car } from './types';

type Variables = {
  id: number;
  startDatetime: string;
  endDatetime: string;
  deliveryAddress?: string;
  returnAddress?: string;
};
type Response = {
  car: Car;
  meta: { numDays: number };
};

export const useCar = createQuery<Response, Variables, AxiosError>({
  queryKey: ['cars'],
  fetcher: ({
    id,
    startDatetime,
    endDatetime,
    deliveryAddress,
    returnAddress,
  }) => {
    const params = new URLSearchParams();

    if (startDatetime) {
      params.append('start_datetime', startDatetime);
    }

    if (endDatetime) {
      params.append('end_datetime', endDatetime);
    }

    params.append('delivery_address', deliveryAddress || '');
    params.append('return_address', returnAddress || '');

    return client.get(`v2/cars/${id}?${params.toString()}`).then((response) => {
      return response.data;
    });
  },
});
